import script from "./CampaignDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignDetail.vue?vue&type=script&setup=true&lang=js"

import "./CampaignDetail.vue?vue&type=style&index=0&id=cbcc3726&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbcc3726"]])

export default __exports__